import {
  AriaButtonProps,
  HoverProps,
  useButton as _useButton,
  useHover,
} from 'react-aria';
import { mergeProps, useObjectRef } from '@react-aria/utils';
import {
  DOMAttributes,
  ElementType,
  RefObject,
} from 'react';

import { FocusableElement } from '@react-types/shared';

export function useButton(
  props: AriaButtonProps<'button'>,
  _ref?: RefObject<HTMLButtonElement>
): {
  buttonProps: DOMAttributes<FocusableElement>;
  isPressed: boolean;
  isHovered: boolean;
};

export function useButton(
  props: AriaButtonProps<'a'> & HoverProps,
  _ref?: RefObject<HTMLAnchorElement>
): {
  buttonProps: DOMAttributes<FocusableElement>;
  isPressed: boolean;
  isHovered: boolean;
};

export function useButton(
  props: AriaButtonProps<ElementType> & HoverProps,
  _ref?: RefObject<any>
): {
  buttonProps: DOMAttributes<FocusableElement>;
  isPressed: boolean;
  isHovered: boolean;
};

export function useButton(
  props: AriaButtonProps<ElementType> & HoverProps,
  _ref?: RefObject<any>
) {
  const ref = useObjectRef(_ref);
  const { buttonProps, isPressed } = _useButton(props, ref);
  const { hoverProps, isHovered } = useHover(props);
  return {
    buttonProps: mergeProps(buttonProps, hoverProps),
    isPressed,
    isHovered,
  };
}
